// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"180":"ca1dee7d","206":"5839e3fa","389":"c3b487c9","631":"7566fd6b","825":"bc001073"}[chunkId] + ".js";
};